import { createAsyncThunk } from '@reduxjs/toolkit';
import apiClient from '../../magpiie-client/client';
import type { Note } from '../types/notes';

export interface CreateNoteDto {
  title?: string;
  content: Record<string, any>;
}

export interface UpdateNoteDto {
  title?: string;
  content?: Record<string, any>;
}

export const fetchNotes = createAsyncThunk(
  'notes/fetchNotes',
  async (_, { rejectWithValue }) => {
    const { data, error } = await apiClient.GET('/v2/notes');
    if (error) return rejectWithValue('Failed to fetch notes');
    return (data ?? []) as Note[];
  }
);

export const createNote = createAsyncThunk(
  'notes/createNote',
  async (dto: CreateNoteDto, { rejectWithValue }) => {
    const { data, error } = await apiClient.POST('/v2/notes', {
      body: dto as any,
    });
    if (error) return rejectWithValue('Failed to create note');
    return data as Note;
  }
);

export const updateNote = createAsyncThunk(
  'notes/updateNote',
  async (
    { id, dto }: { id: number; dto: UpdateNoteDto },
    { rejectWithValue }
  ) => {
    const { data, error } = await apiClient.PATCH('/v2/notes/{id}', {
      params: { path: { id } },
      body: dto as any,
    });
    if (error) return rejectWithValue('Failed to update note');
    return data as Note;
  }
);

export const deleteNote = createAsyncThunk(
  'notes/deleteNote',
  async (id: number, { rejectWithValue }) => {
    const { error } = await apiClient.DELETE('/v2/notes/{id}', {
      params: { path: { id } },
    });
    if (error) return rejectWithValue('Failed to delete note');
    return id;
  }
);
